import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-context-nav-tree',
  templateUrl: './context-nav-tree.component.html',
  styleUrls: ['./context-nav-tree.component.scss']
})
export class ContextNavTreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
